module.exports = __webpack_public_path__ + "img/PLCConfig_1-1.068e305b.png";